<!--<template>
  <div class="pi-container">
    <div class="grid">
      <div class="grid-card" :style="{backgroundColor: `#000E79`}">
        <div class="bg-title mb-3 white-color" v-html="'Iam Instructor '"></div>
        <div class="card-flex">
          <div class="text mb-3 white-color" v-html="'Global Council for Law, Arbitration and Intellectual Property<br /> (GCLA) is One of driven new ways of thinking since our 1998 founding.'"></div>
          <router-link to="/" class="pi-btn">Explore</router-link>
        </div>
      </div>
      <div class="grid-card" :style="{backgroundColor: `#AF8916`}">
        <div class="bg-title mb-3 white-color" v-html="'GCLA Programs '"></div>
        <div class="card-flex">
          <div class="text mb-3 white-color" v-html="'Global Council for Law, Arbitration and Intellectual Property<br /> (GCLA) is One of driven new ways of thinking since our 1998 founding.'"></div>
          <router-link to="/" class="pi-btn">Explore</router-link>
        </div>
      </div>
    </div>
  </div>
</template> -->

<template>
  <div class="pi-container">
    <div class="grid">
      <div class="grid-card" :style="'backgroundColor:'+row.bgColor1">
        <div class="bg-title mb-3 white-color" v-html="row.title1"></div>
        <div class="card-flex">
          <div class="text mb-3 white-color" v-html="row.body1"></div>
          <router-link v-if="row.redirect1" :to="row.redirect1" class="pi-btn" v-html="row.button1"></router-link>
        </div>
      </div>
      <div class="grid-card" :style="'backgroundColor:'+row.bgColor2+ ' !important'">
        <div class="bg-title mb-3 white-color" v-html="row.title2"></div>
        <div class="card-flex">
          <div class="text mb-3 white-color" v-html="row.body2"></div>
          <router-link v-if="row.redirect2" :to="row.redirect2" class="pi-btn" v-html="row.button2"></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pi-container {
  padding: 0.7rem 0
}
.grid {
  display: grid;
  grid-template-columns: repeat(2,minmax(0,1fr));
  grid-gap: 12.25rem;
  gap: 0.7rem;
  width: 100%;
}
.grid-card {
  padding: 40px 35px
}
.text {
  line-height: 1.5;
}
.pi-btn {
  color: #fff;
  font-size: 18px;
  border: 1px solid #fff;
  padding: 5px 18px;
  line-height: 1;
  display: inline-block;
}
.pi-btn:hover {
  background: #fff;
  color: #000;
}
.pi-btn:active {
  opacity: 0.6;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
}

@media (max-width: 767.98px) {
  .grid {
    grid-template-columns: repeat(1,minmax(0,1fr));
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>

<script>
export default {
  name: "Section1",
  props: ["row"],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
    //
  },
  methods: {
    //
  },
};
</script>
